// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-module__spinner","inner":"Spinner-module__inner","spin":"Spinner-module__spin","white":"Spinner-module__white"};